import { Box } from '@chakra-ui/react'
import { GreyGrey80 } from '@sequencehq/design-tokens'

export const ReadOnlyItem = (props: { label: string; value: string }) => (
  <>
    <Box>{props.label}</Box>
    <Box color={GreyGrey80}>{props.value}</Box>
  </>
)
